module.exports = __webpack_public_path__ + "public/assets/img/logo.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/img/logo.png
// module id = 1437
// module chunks = 0